import { render, staticRenderFns } from "./Notificacion.modal.vue?vue&type=template&id=00d28c80&scoped=true&"
import script from "./Notificacion.modal.vue?vue&type=script&lang=js&"
export * from "./Notificacion.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d28c80",
  null
  
)

export default component.exports